import React from "react";
import { useQuiz } from "../context/QuizContext";

export default function ResetButton() {
  const { dispatch } = useQuiz();

  return (
    <button
      className={"btn btn-ui"}
      onClick={() => dispatch({ type: "reset" })}
      style={{ display: "block", margin: "auto" }}
    >
      Try Again
    </button>
  );
}
